import { useParams, Redirect } from "react-router-dom";
import { useTypedSelector } from "../../../../../../../store/reducers/use-typed-selector";
import { PageModuleType, SessionPanelLayoutsTypes, SessionTabNames } from "../../../../../../../types/working-model";
import { useGetAdminUrl } from "../../../../../../../utils/admin-routing-utils";
import { ParamsProps } from "../../../../../../live-event/live-event";
import ActiveProductsList from "../extras/products/active-products-list";
import { usePageModuleGroup } from "../hooks/panel.hooks";
import EmptyStatePanel from "./empty-state-panel";
import { PageModuleTypeMap, SessionPanelMap } from "../session-panel-route-map";
import EmbedSection from "../extras/embed/embed-section";
import ActiveSpeakersList from "../extras/speakers/active-speakers-list";
import { useHistoryState } from "../../../../../../../utils/use-history-state";

// custom tabs can be of any content type OR be empty
// currently, I am using the empty and unused .feed type to hold onto any 
// custom tabs that have no content because we won't know what type they are 
// until the user picks a content type, at that point we'll update the page_module type to match
// the content type
export const CustomTab: React.FC<unknown> = () => {
	const { page_module } = useParams<ParamsProps>();
	const workingSession = useTypedSelector(state => state.CreateSessionReducer.workingSession);
	const moduleType = workingSession?.modules.find(module => module.id === parseInt(page_module))?.type;

	const tabRenderer = (type: PageModuleType) => {
		switch (type) {
			case PageModuleType.products:
				return <ActiveProductsList />;
			case PageModuleType.documents:
				return <></>;
			case PageModuleType.similar_sessions:
				return <></>;
			case PageModuleType.speakers:
				return <ActiveSpeakersList />;
			case PageModuleType.blank:
				return <EmbedSection />;
			case PageModuleType.feed:
			default: {
				return (
					<EmptyStatePanel
						title="Add Content to Custom Tab"
						description="Tabs without content will not be visible to the audience"
					/>
				);
			}
		}
	};

	return tabRenderer(moduleType ?? PageModuleType.feed);
};

export default function ExtrasPanel(): JSX.Element {
	const workingSession = useTypedSelector(state => state.CreateSessionReducer.workingSession);
	const adminPath = useGetAdminUrl();
	const group = usePageModuleGroup();
	const historyState = useHistoryState();

	// when the user arrives at the custom tab for the first time, redirect to the first subtab (which may be invisible)
	const getFirstTab = () => {
		const typeMap = PageModuleTypeMap('extras');
		const firstModule = workingSession?.modules.find(module => group?.modules?.includes(module.id as number));
		const type = firstModule?.type;

		if (type) {
			const panel = typeMap[type];
			if (panel) {
				return adminPath({ path: SessionPanelMap[panel as SessionPanelLayoutsTypes] ?? SessionPanelMap[SessionTabNames.Content_v2], page_module: firstModule?.id });
			}
		}

		return adminPath({ path: SessionPanelMap[SessionTabNames.Content_v2] });
	};

	return (
		<>
			{!!group && (
				<Redirect to={{ pathname: getFirstTab(), state: historyState }} />
			)}
		</>
	);
}
